import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import TransportHubsSearchInput from "../../../NewSearchSateInput/TransportHubsSearchInput";
import MultiSelectSearch from "../../../NewSearchSateInput/MultiSelectSearch";
import styles from "./EditNewUiSearchFormTransport.module.scss";
import NewUiMultiSelectSearch from "../../../NewSearchSateInput/NewUiMultiSelectSearch";
import NewUiTransportHubsSearchInput from "../../../NewSearchSateInput/NewUiTransportHubsSearchInput";
import { SvgMan, SvgSearch, SvgWatch } from "../../../../utils/svgIcons";
import { capitalizeFirstLetter, getDateByMonth } from "../../../../utils/utils";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

function EditNewUiSearchFormTransport({
  includingDestinations,
  searchType,
  singleHotelPage,
  singleHotelData,
}) {
  const [modifyPkg, setModiyPkg] = useState(false);
  const [mobileHead, setMobileHead] = useState(false);
  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };
  const [startDestination, setStartDestination] = useState("");
  const [endDestination, setEndDestination] = useState("");
  const [noOfDays, setNoOfDays] = useState("");
  const [date, setDate] = useState(new Date());
  const [destinationToggle, setdestinationToggle] = useState(false);

  const getDataFromChild = (data, resultArray) => {
    setStartDestination(data);
    // setStateResultArray(resultArray)
    // console.log(resultArray);
  };

  const getDataFromChildForToCity = (data, resultArray, selectedType) => {
    setEndDestination(data);
    // setSelectedType(selectedType);
  };

  const [guestDetails, setIsguestDetails] = useState(false);
  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [data, setData] = useState({ fromCity: "", toCity: "" });

  const showErrorToast = (message) => {
    alert(message);
  };

  const [bookingData, setBookingData] = useState({});
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const navigate = useNavigate();

  // Date alterations
  const [loader, setLoader] = useState(false);

  const dropdownRef = useRef(null);

  const popupsRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupsRef.current && !popupsRef.current.contains(event.target)) {
        setIsguestDetails(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleSubmitButtonClickHandler = async (e) => {
    setLoader(true);

    if (e) {
      e.preventDefault();
    }

    try {
      await navigate(
        `/transport/listing?startdestination=${startDestination}&noOfDays=${noOfDays}&date=${new Date(
          date
        ).getDate()}&month=${new Date(date).getMonth() + 1}&year=${new Date(
          date
        ).getFullYear()}&selectedDestination=${selectedMultipleDestinations?.length
        }`,
        {
          state: {
            includingDestinations: selectedMultipleDestinations,
          },
        },
        undefined,
        { shallow: false }
      );
      setLoader(false);
      setModiyPkg(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
      setModiyPkg(false);
    } finally {
      setLoader(false);
    }
  };

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const updateDimensions = () => {
    // console.log("window.innerWidth", window.innerWidth);

    if (width > 640) {
      setMobileHead(false);
    } else {
      setMobileHead(true);
    }
  };

  useEffect(() => {
    // Call the function on initial render
    // updateDimensions();

    // Add event listener for window resize
    window.addEventListener("resize", updateDimensions);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", updateDimensions);
  }, [width]);

  const [selectedMultipleDestinations, setSelectedMultipleDestinations] =
    useState([]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const data = {
      adult: params.get("adult"),
      date: params.get("date"),
      year: params.get("year"),
      month: params.get("month"),
      noOfDays: params.get("noOfDays"),
      startDestination: params.get("startdestination"),
      endDestination: params.get("enddestination"),
    };

    const travelDate = `${data.year}-${String(data.month).padStart(
      2,
      "0"
    )}-${String(data.date).padStart(2, "0")}`;
    setBookingData({ ...data, travelDate });
    setDate(travelDate);
    setNoOfDays(data?.noOfDays);
    setStartDestination(data?.startDestination);
    setEndDestination(data?.endDestination);

    if (includingDestinations?.length) {
      setSelectedMultipleDestinations(includingDestinations);
    }
  }, [location.search, includingDestinations]);

  const handleMultiDestinationsChange = (selected) => {
    setSelectedMultipleDestinations(selected);
  };

  return (
    <section className={styles.EditSearchParentWrapper}>
      <div className={styles.singleSearch} id="singleSearch">
        <form
          action=""
          className={styles.EditSearchFormWrapper}
          id="main-form"
          onSubmit={handleSubmitButtonClickHandler}
        >
          {/* {width} */}
          {width <= 640 ? (
            <>
              {/* <div style={{padding:"10px"}} className="SingleSearch-Resp flex_align_center justify_content_between">
                <div className="flex_align_center">
                  <span onClick={() => window.history.back()}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                        fill="#333333"
                      />
                    </svg>
                  </span>
                  <div className="SingleSearch-resp_content">
                    <h4 style={{ fontSize: "16px", lineHeight: "20px" }}>
                      <p>Enter Hub</p>
                    </h4>
                    <div style={{ fontSize: "14px", lineHeight: "20px" }}>
                      <span>{startDestination}</span>
                    </div>
                  </div>
                </div>
                <div onClick={toggleModify}>
                  {modifyPkg ? (
                    <span style={{ marginRight: "10px" }}>X</span>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_2797_7470"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_2797_7470)">
                        <path
                          d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8507 2.70833 14.0521 2.625C14.2535 2.54167 14.4653 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.309 4.5 17.3854 4.70833C17.4618 4.91667 17.5 5.125 17.5 5.33333C17.5 5.55556 17.4618 5.76736 17.3854 5.96875C17.309 6.17014 17.1875 6.35417 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z"
                          fill="#333333"
                        />
                      </g>
                    </svg>
                  )}
                </div>
              </div> */}
              <div className={styles.mobile_new_wrapper_container}>
                <div
                  onClick={toggleModify}
                  className={styles.mobile_new_wrapper}
                >
                  <div className={styles.mobile_new_left_div}>
                    <div>
                      {" "}
                      <SvgSearch />
                    </div>
                    <div className={styles.mobile_new_left_div_location}>
                      {startDestination &&
                        capitalizeFirstLetter(startDestination)}
                      {/* <span>{getDateByMonth(bookingData?.date)}</span> */}
                    </div>
                  </div>

                  <div className={styles.mobile_new_right_div}>
                    {/* <div className={styles.mobile_new_right_div_svg}>
                      <SvgMan />
                    </div>
                    <div className={styles.mobile_new_right_div_guest}>
                      {" "}
                      {guest}
                    </div> */}
                  </div>
                </div>

                {modifyPkg && (
                  <div className={styles.lower_form}>
                    <div>
                      <label htmlFor="">Starting From</label>

                      <TransportHubsSearchInput
                        onClick={() => setdestinationToggle(true)}
                        onDataChange={getDataFromChild}
                        dropdownGuestDetails={dropdownGuestDetails}
                        setIsguestDetails={setIsguestDetails}
                        className={"testform_input"}
                        width={width}
                      />
                    </div>
                    <div className="">
                      <label htmlFor="">Including Destinations</label>
                      <MultiSelectSearch
                        onClick={() => setdestinationToggle(true)}
                        onMultiSelectionChange={handleMultiDestinationsChange}
                        defaultSelected={selectedMultipleDestinations}
                        className={"testform_input"}
                        width={width}
                      />
                    </div>
                    <div className="search_form_div">
                      <label htmlFor="">No. of Days</label>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="number"
                          value={noOfDays}
                          onChange={(e) => setNoOfDays(e.target.value)}
                          className="testform_input"
                        />
                        <SvgWatch />
                      </div>

                    </div>
                    <div className="search_form_div p_0 icon_button_only">
                      <label>Departure Date</label>
                      {/* <Flatpickr
                        className=" w_full m_0 testform_input"
                        color="#ffffff"
                        value={date}
                        onChange={([date]) => setDate(date)}
                        min={new Date()}
                        // f
                        options={{
                          minDate: "today",
                        }}
                      /> */}

                      <div className={`new_date_picker_react_js_custom_styling`}>
                        <DatePicker
                          selected={date}
                          onChange={(date) => setDate(date)}
                          portalId="root-portal NewUIReactDatePicker"
                          popperPlacement="bottom-start"
                          minDate={new Date()}
                          dateFormat="dd MMM, yyyy"
                          placeholderText={date ? format(date, "dd MMM, yyyy") : "Travel Date"}
                        />
                      </div>
                    </div>
                    <button
                      style={{ marginTop: "10px" }}
                      type="submit"
                      className={styles.submitButton}
                    >
                      Modify
                      <span>
                        {" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="12"
                          viewBox="0 0 17 12"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_6093_5578)">
                            <path
                              d="M16.5488 5.27416C12.5086 4.76301 11.0605 0.540892 11.0395 0.5L10.0426 0.816914C10.0951 0.980483 11.1235 3.97584 13.9253 5.48885H0V6.51115H13.9253C11.134 8.02416 10.0951 11.0297 10.0426 11.1831L11.0395 11.5C11.0395 11.5 12.5086 7.23699 16.5488 6.72584L17.0105 6.6645V5.32528L16.5488 5.26394V5.27416Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6093_5578">
                              <rect
                                width="17"
                                height="11"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className={styles.EditSearchFormParent}>
              <div className={styles.EditSearchFormChild}>
                <div className={styles.EditSearchFormChildFirstDiv}>
                  <NewUiTransportHubsSearchInput
                    onClick={() => setdestinationToggle(true)}
                    onDataChange={getDataFromChild}
                    dropdownGuestDetails={dropdownGuestDetails}
                    setIsguestDetails={setIsguestDetails}
                    className={"testform_input"}
                  />
                </div>
                <div className={styles.EditSearchFormChildSecondDiv}>
                  <NewUiMultiSelectSearch
                    onClick={() => setdestinationToggle(true)}
                    onMultiSelectionChange={handleMultiDestinationsChange}
                    className={"testform_input"}
                    defaultSelected={selectedMultipleDestinations}
                  />
                </div>
                <div className={styles.EditSearchFormChildThirdDiv}>
                  {/* <label htmlFor="">No. of Days</label> */}
                  <input
                    style={{ outline: "none", border: "none" }}
                    type="number"
                    value={noOfDays}
                    onChange={(e) => setNoOfDays(e.target.value)}
                    className="testform_input"
                  />
                </div>
                <div className={`${styles.EditSearchFormChildFourthDiv} new_date_picker_react_js_custom_styling`}>
                  {/* <label>Departure Date</label> */}
                  {/* <Flatpickr
                    style={{ outline: "none", border: "none" }}
                    className=" testform_input"
                    color="#ffffff"
                    value={date}
                    onChange={([date]) => setDate(date)}
                    min={new Date()}
                    // f
                    options={{
                      minDate: "today",
                    }}
                  /> */}

                  <DatePicker
                    showIcon
                    selected={date}
                    onChange={(date) => setDate(date)}
                    portalId="root-portal NewUIReactDatePicker"
                    popperPlacement="bottom-start"
                    minDate={new Date()}
                    dateFormat="dd MMM, yyyy"
                    placeholderText={date ? format(date, "dd MMM, yyyy") : "Travel Date"}
                  />
                </div>
              </div>

              <button type="submit" className={styles.submitButton}>
                Modify
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <mask
                      id="mask0_6818_5962"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="15"
                      height="15"
                    >
                      <rect width="15" height="15" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6818_5962)">
                      <path
                        d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                        fill="white"
                      />
                    </g>
                  </svg>
                </span>
              </button>
            </div>
          )}
        </form>

        <input type="hidden" name="hotelId" value="{{ $hotelId }}" />
      </div>
    </section>
  );
}

export default EditNewUiSearchFormTransport;
